// Avatar images from CDN
const AVATAR_CDN_BASE = 'https://video.yepai.io/avataroutputs';

// Helper to generate avatar URL
export const getAvatarUrl = (name: string) =>
  `${AVATAR_CDN_BASE}/${name.toLowerCase()}/${name}.png`;

export const avatarImages = {
  // Existing avatars
  Rebecca: getAvatarUrl('Rebecca'),
  Bella: getAvatarUrl('Bella'),
  Emily: getAvatarUrl('Emily'),
  Isaiah: getAvatarUrl('Isaiah'),
  Phoebe: getAvatarUrl('Phoebe'),
  Ethan: getAvatarUrl('Ethan'),
  Maxwell: getAvatarUrl('Maxwell'),
  Vivian: getAvatarUrl('Vivian'),
  Naomi: getAvatarUrl('Naomi'),
  Rita: getAvatarUrl('Rita'),
  Kim: getAvatarUrl('Kim'),
  Kylie: getAvatarUrl('Kylie'),
  Jackson: getAvatarUrl('Jackson'),
  Eva: getAvatarUrl('Eva'),
  // New avatars
  Alex: getAvatarUrl('Alex'),
  Cynthia: getAvatarUrl('Cynthia'),
  Jacob: getAvatarUrl('Jacob'),
  James: getAvatarUrl('James'),
  John: getAvatarUrl('John'),
  Justin: getAvatarUrl('Justin'),
  Ken: getAvatarUrl('Ken'),
  Luna: getAvatarUrl('Luna'),
  Marry: getAvatarUrl('Marry'),
  Mike: getAvatarUrl('Mike'),
  Molly: getAvatarUrl('Molly'),
  Oliver: getAvatarUrl('Oliver'),
  Selina: getAvatarUrl('Selina'),
  Shirley: getAvatarUrl('Shirley'),
  Victoria: getAvatarUrl('Victoria'),
  Rain: getAvatarUrl('Rain'),
};
